import { Component, OnInit } from '@angular/core';
import { TransactionService } from '../../../../services/transaction/transaction.service';
import { CommonFunctionService } from '../../../../services/Common/common-function.service';
import { RegisterUserService } from '../../../../services/registerUser/register-user.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
const _clone = (d) => JSON.parse(JSON.stringify(d));

@Component({
  selector: 'app-payoutwelcomepage',
  templateUrl: './payoutwelcomepage.component.html',
  styleUrls: ['./payoutwelcomepage.component.scss'],
})
export class PayoutwelcomepageComponent implements OnInit {
  selected = 0;
  PayGSetUpgideshow: boolean = true;
  payoutgideshow: boolean = false;
  prepaidcard: boolean = false;
  rows = [];
  tab: any = 'tab1';
  tab1: any;
  tab2: any;
  tab3: any;
  Clicked: boolean;
  CurrentIp: any;
  browser: any;
  LogoContent: any;
  MerchantLogo: boolean = false;
  PaygLogo: boolean = false;
  content: any;
  username: any;
  ManageLinks: boolean = true;
  NewLink: boolean = false;
  ReportsLink: boolean = false;
  Payout: boolean = false;
  card: boolean = false;
  merchantKeyId: any;
  resellerno: any;
  businessName;
  constructor(
    private bnIdle: BnNgIdleService,
    private router: Router,
    private commonfunction: CommonFunctionService,
    private ip: TransactionService,
    private registerUserService: RegisterUserService
  ) {
    this.username = this.commonfunction.getUserName();
    this.merchantKeyId =
      this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    this.getMerchantInfo();
    localStorage.removeItem('MerchantLogo');
    if (environment.disableUserKycAndUserProfileApiCall == false) {
      this.registerUserService
        .getMerchantLogoInfo(this.merchantKeyId)
        .subscribe((result) => {
          this.LogoContent = result;
          if (
            this.LogoContent.length != 0 &&
            this.LogoContent.length != undefined
          ) {
            if (
              result[0].Content != 'NULL' ||
              result[0].Content != '' ||
              result[0].Content != undefined
            ) {
              // if(result[0] .Length == "null" )
              this.content = result[0].Content;
              localStorage.setItem('MerchantLogo', this.content);
              this.PaygLogo = false;
              this.MerchantLogo = true;
            }
          } else {
            this.PaygLogo = true;
            this.MerchantLogo = false;
          }
        });
    }
  }
  gotoProceed(i) {
    this.selected == i ? (this.selected = i + 1) : (this.selected = i);
    this.ManageLinks = true;
    this.NewLink = false;
    this.ReportsLink = false;
    this.Payout = false;
    this.card = false;
  }
  gotoNew(i) {
    this.selected == i ? (this.selected = i + 1) : (this.selected = i);
    this.ManageLinks = false;
    this.NewLink = true;
    this.ReportsLink = false;
    this.Payout = false;
    this.card = false;
  }
  gotoReports(i) {
    this.selected == i ? (this.selected = i + 1) : (this.selected = i);
    this.ManageLinks = false;
    this.NewLink = false;
    this.ReportsLink = true;
    this.Payout = false;
    this.card = false;
  }
  gotoPayout(i) {
    this.selected == i ? (this.selected = i + 1) : (this.selected = i);
    this.ManageLinks = false;
    this.NewLink = false;
    this.ReportsLink = false;
    this.Payout = true;
    this.card = false;
  }
  gotoPrepaidcard(i) {
    this.selected == i ? (this.selected = i + 1) : (this.selected = i);
    this.ManageLinks = false;
    this.NewLink = false;
    this.ReportsLink = false;
    this.Payout = false;
    this.card = true;
  }

  onClick(check) {
    //    console.log(check);
    if (check == 1) {
      this.tab = 'tab1';
    } else if (check == 2) {
      this.tab = 'tab2';
    } else {
      this.tab = 'tab3';
    }
  }

  onSwitch(check) {
    switch (check) {
      case 1:
        return 'tab1';
      case 2:
        return 'tab2';
      case 3:
        return 'tab3';
    }
  }

  ngOnInit() {
    this.getIP();
    this.getMerchantServicesAndFees();
  }

  getMerchantServicesAndFees() {
    this.registerUserService
      .getMerchantServicesAndFees(this.merchantKeyId, this.resellerno)
      .subscribe((result) => {
        if (result != null) {
          this.rows = _clone(result);

          this.rows.forEach((element) => {
            if (element.ServiceCode == 'PayOut' && element.Status == 1) {
              this.payoutgideshow = true;
            }
            if (element.ServiceCode == 'PayGSetUp' && element.Status == 1) {
              this.PayGSetUpgideshow = true;
            }
            if (element.ServiceCode == 'PayGSetUp' && element.Status == 0) {
              this.PayGSetUpgideshow = false;
              this.gotoNew(1);
            }
            if (element.ServiceCode == 'PrepaidCard' && element.Status == 1) {
              this.prepaidcard = true;
            }
            // else {
            //   this.payoutgideshow=false;
            // }
          });
        }

        console.log('fee services ', result);
        //this.rows = _clone(result);
      });
  }

  getMerchantInfo() {
    this.registerUserService
      .isValidMerchantKeyId(this.merchantKeyId, this.resellerno)
      .subscribe((result) => {
        this.businessName = result.CompanyName;
      });
  }

  getIP() { 
      this.CurrentIp = localStorage.getItem('ipaddress');;
      const agent = window.navigator.userAgent.toLowerCase();
      switch (true) {
        case agent.indexOf('edge') > -1:
          this.browser = 'edge';
          return;
        case agent.indexOf('opr') > -1 && !!(<any>window).opr:
          this.browser = 'opera';
          return;
        case agent.indexOf('chrome') > -1 && !!(<any>window).chrome:
          this.browser = 'chrome';
          return;
        case agent.indexOf('trident') > -1:
          this.browser = 'ie';
          return;
        case agent.indexOf('firefox') > -1:
          this.browser = 'firefox';
          return;
        case agent.indexOf('safari') > -1:
          this.browser = 'safari';
          return;
      } 
  }
}
